export default __webpack_public_path__ + "img/customAlerts.81f794d2.png";